'use strict';

angular.module('common').directive("disableAnimation", function ($animate) {
  return function ($scope, $element) {
    $animate.enabled(false, $element);
  };
});